import { AppState } from "@Store/index";
import getCookie from "helpers/getCookie";
import { shallowEqual, useSelector } from "react-redux";

const useCookies = (cname: string) => {
  const { whiteListedCookies } = useSelector(
    ({ appData }: AppState) => ({
      whiteListedCookies: appData.whiteListedCookies,
    }),
    shallowEqual,
  );
  if (__CLIENT__) return getCookie(cname);
  return whiteListedCookies[cname] || null;
};

export default useCookies;
